"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const status_codes_1 = require("@biorad-lsg-tsc/status-codes");
const http_status_codes_1 = require("http-status-codes");
const contains_all_1 = require("./contains-all");
const jwt_1 = __importDefault(require("./jwt"));
const encryption_1 = __importDefault(require("./encryption"));
class UserPermissions {
    constructor(accessToken) {
        this.decodedAccessToken = jwt_1.default.decodeJwt(accessToken);
    }
    getKey(key) {
        return this.decodedAccessToken[key];
    }
    get tenantId() {
        return this.getKey('tenantId');
    }
    get id() {
        return this.getKey('id');
    }
    get email() {
        return this.getKey('email');
    }
    get userCognitoId() {
        return this.getKey('userCognitoId');
    }
    get roles() {
        return this.getKey('roles');
    }
    get permissions() {
        return this.getKey('permissions');
    }
    get iat() {
        return this.getKey('iat');
    }
    get exp() {
        return this.getKey('exp');
    }
    get tenantName() {
        return this.getKey('tenantName');
    }
    hasRoles(roles) {
        return (0, contains_all_1.containsAll)(this.roles, roles);
    }
    hasPermissions(permissions) {
        return (0, contains_all_1.containsAll)(this.permissions, permissions);
    }
    static async getUserPermissions(headers) {
        const accessToken = UserPermissions.extractHeaderAccessToken(headers);
        try {
            const decryptedToken = await encryption_1.default.decryptToken(accessToken);
            return new UserPermissions(decryptedToken);
        }
        catch (e) {
            console.log(`There was an error decrypting the token: ${e}`);
            throw new status_codes_1.StatusCodeError(http_status_codes_1.StatusCodes.UNAUTHORIZED, 'Invalid access token');
        }
    }
    static extractHeaderAccessToken(headers) {
        const { 'access-token': token } = headers;
        if (!token)
            throw new status_codes_1.BadRequestError('Access token is missing');
        const parsedToken = JSON.parse(token);
        return parsedToken.accessToken;
    }
}
exports.default = UserPermissions;
